import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/icons/icon-question-color.svg'
import _imports_1 from '@/assets/icons/arrow-up-builder-message.svg'


const _hoisted_1 = { class: "content-info-and-message" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "house-info-card-row" }
const _hoisted_4 = { class: "row-value" }
const _hoisted_5 = { class: "house-info-card-row" }
const _hoisted_6 = { class: "row-value color-info" }
const _hoisted_7 = { class: "house-info-card-row" }
const _hoisted_8 = { class: "row-value color-info" }
const _hoisted_9 = { class: "content-button" }
const _hoisted_10 = {
  key: 0,
  class: "icon-question",
  src: _imports_0
}
const _hoisted_11 = {
  key: 1,
  class: "icon-arrow",
  src: _imports_1
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["house-info-card", { isOpenInfo: $setup.fadeInEffect }])
    }, [
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "title" }, "Your Selections", -1)),
      ($setup.props.selections)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "row-label" }, "House Design", -1)),
              _createElementVNode("div", _hoisted_4, _toDisplayString($setup.props?.houseName || "--"), 1)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "row-label" }, "Exterior Facade", -1)),
              _createElementVNode("div", _hoisted_6, _toDisplayString($setup.props.selections.facade?.name || "--"), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "row-label" }, "Floorplan", -1)),
              _createElementVNode("div", _hoisted_8, _toDisplayString($setup.props.selections.floorplan?.name || "--"), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("button", {
          class: _normalizeClass(["button default primary message", { changeButton: $setup.fadeInEffect }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.openDesignModification()))
        }, [
          _cache[4] || (_cache[4] = _createTextVNode("Can I make a design modification", -1)),
          (!$setup.fadeInEffect)
            ? (_openBlock(), _createElementBlock("img", _hoisted_10))
            : (_openBlock(), _createElementBlock("img", _hoisted_11))
        ], 2)
      ])
    ], 2),
    _createVNode($setup["BuilderOpenMessageReviewQuote"], {
      isOpen: $setup.isDesignModification,
      type: $setup.BuilderMessageType.CHANGE_REQUEST,
      selections: $setup.props.selections,
      class: _normalizeClass({ isOpen: $setup.fadeInEffect })
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "actions", {}, undefined, true)
      ]),
      _: 3
    }, 8, ["isOpen", "type", "selections", "class"])
  ]))
}